import { makeStyles, shorthands } from '@fluentui/react-components';

export const useMapStyles = makeStyles({
  container: {
    height: '240px',
    width: '100%',
    '& .tool-tip-container': {
      ...shorthands.padding('15px'),
      boxShadow: '0 3.2px 7.2px 0 rgba(0,0,0,.132), 0 0.6px 1.8px 0 rgba(0,0,0,.108)',
      backgroundColor: 'rgba(255, 255, 255, 0.95)',
      '@supports (backdrop-filter: blur(60px))': {
        backdropFilter: 'blur(60px)',
        backgroundColor: 'rgba(255, 255, 255, 0.25)',
      },

      '& .date-range': {
        whiteSpace: 'nowrap',
        ...shorthands.margin('10px 0'),
      },
      '& .metric-container': {
        display: 'flex',
        alignItems: 'center',
      },
      '& .metric-container .metric-name': {
        marginRight: '5px',
      },
      '& .metric-container .metric-value': {
        fontWeight: 'bold',
      },
      '& .bubble-icon': {
        width: '12px',
        height: '12px',
        ...shorthands.borderStyle('solid'),
        ...shorthands.borderWidth('1px'),
        ...shorthands.borderColor('#107C10'),
        ...shorthands.borderRadius('6px'),
        marginRight: '5px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
      '& .bubble-icon .dot': {
        width: '4px',
        height: '4px',
        ...shorthands.borderStyle('solid'),
        ...shorthands.borderWidth('2px'),
        ...shorthands.borderColor('#107C10'),
        ...shorthands.borderRadius('4px'),
        backgroundColor: '#107C10',
      },
    },
  },
});

